import loadGateScript, { confirmGateDefined, smartformsBundleSrc } from './smartforms_gate_loader';

// TechTarget's smartforms registration form, shown instead of the regular content gate
// on TechTarget articles other than trackers (see renderGate() in editorial_gate.js). After a
// successful submission the component sets its own session cookies and reloads the
// page, so it only needs to be mounted.

const SMARTFORMS_LOAD_TIMEOUT_MS = 10000;

// TechTarget registration ids, not Django's SITE_ID. 151 is TechTarget's
// inline-registration app code.
const SMARTFORMS_APP_CODE = '151';

// TechTarget registration site ids, keyed by the name of the community (the newspost's
// preferred topic) the gate is shown in. Each registration site is named after its
// community, and the name is sent along with the id: TT's registration service looks the
// site up by name, so an id without its matching name would register the user against a
// different site.
const SMARTFORMS_COMMUNITY_SITE_IDS = {
  AI: '3226',
  Infrastructure: '3227',
  Data: '3228',
  CIO: '3230',
  Cybersecurity: '3231',
};
// TT's catch-all TechTarget registration site, for pages outside the communities above.
const SMARTFORMS_DEFAULT_SITE = { id: '36', name: 'techtarget' };

// `community` is set from the techtarget_community context in content_gate.html, matched
// ignoring case. Pages with no community, or one not listed above, register against the
// default TechTarget site.
export function smartformsSite(community = window.techtargetCommunity) {
  const name = Object.keys(SMARTFORMS_COMMUNITY_SITE_IDS)
    .find((key) => key.toLowerCase() === (community || '').toLowerCase());
  return name ? { id: SMARTFORMS_COMMUNITY_SITE_IDS[name], name } : SMARTFORMS_DEFAULT_SITE;
}

// Set from the ON_TECHTARGET setting in content_gate.html.
export function isTechTargetDiveSite() {
  return window.onTechTarget === true;
}

// `gate` is the signupGate object from editorial_gate.js; its layout helpers are reused
// so the overlay sits where the regular gate's would.
export function setUpSmartformsGate(gate) {
  const site = smartformsSite();

  window.signupGate = gate;

  gate.increasePaddingForSocialTags();
  gate.hideCreditSection();
  gate.hideSignups();
  gate.hideFirstAd();
  gate.addOverlayCss();
  gate.addStructuredDataClass();
  gate.$overlay.appendTo(gate.cssClass);
  gate.updateMaxHeightForOverlay();

  // Same position as the regular gate form; $overlay is only the fade-out backdrop.
  const $smartformsGateContainer = $('<div id="smartforms_techtarget_gate"></div>');
  $smartformsGateContainer.insertAfter($(gate.articleBody));

  const mountSmartformsGate = () => {
    const smartformsGateEl = document.createElement('smartforms-techtarget');
    // Required.
    smartformsGateEl.setAttribute('format', 'inline');
    smartformsGateEl.setAttribute('site-id', site.id);
    smartformsGateEl.setAttribute('site-name', site.name);
    smartformsGateEl.setAttribute('app-code', SMARTFORMS_APP_CODE);
    // Optional.
    smartformsGateEl.setAttribute('language', 'en');
    // The newspost's itt_id, rendered as contentId by templates/snippets/techtarget_context.html.
    const ittId = window.techtargetContext?.contentId;
    if (ittId) {
      smartformsGateEl.setAttribute('ad-id', ittId);
    }

    $smartformsGateContainer.append(smartformsGateEl);
    gate.$overlay.show();
  };

  const fallBackToContentGate = () => {
    $smartformsGateContainer.remove();
    gate.setUpContentGate();
  };

  // The timeout starts with the load, so it also covers a request that never completes.
  Promise.all([
    loadGateScript(smartformsBundleSrc()),
    confirmGateDefined('smartforms-techtarget', SMARTFORMS_LOAD_TIMEOUT_MS),
  ])
    // A rejection handler rather than .catch(), so an error while mounting doesn't also
    // render the fallback gate.
    .then(mountSmartformsGate, fallBackToContentGate);
}
